// ==========================================
// 1. DEFINICIÓN DE FUNCIONES INDIVIDUALES
// ==========================================

function assignRoleToFlags() {
    const flagElements = document.querySelectorAll(".flags");
    flagElements.forEach((element) => {
        element.setAttribute("role", "button");
        element.setAttribute("tabindex", 0);
    });
    console.log(`Assigned role="button" to ${flagElements.length} elements.`);
    const spanElement = document.querySelector("span.current.notranslate");
    if (spanElement) {
        spanElement.setAttribute("role", "button");
        spanElement.setAttribute("tabindex", "0");
        console.log("Attributes added successfully!");
    } else {
        console.log("No matching span element found.");
    }
}

function assignRoleNoneToFigureCardMedia() {
    const elements = document.querySelectorAll("figure.card-media");
    elements.forEach((element) => {
        element.setAttribute("role", "none");
    });
    console.log(`Added role="none" to ${elements.length} <figure> elements.`);
}

function assignRoleNoneToFigureWidgetMedia() {
    const elements = document.querySelectorAll("figure.widget-media");
    elements.forEach((element) => {
        element.setAttribute("role", "none");
    });
    console.log(`Added role="none" to ${elements.length} <figure> elements.`);
}

function enhanceCurrentPageLink() {
    const links = document.querySelectorAll('a[aria-current="page"].current');
    links.forEach((link) => {
        link.setAttribute("aria-haspopup", "true");
        link.setAttribute("role", "button");
    });
    console.log(`Added aria-haspopup="true" and role="button" to ${links.length} <a> elements.`);
}

function addAriaLabelToMobileExpandButton() {
    const buttons = document.querySelectorAll("button.navigation-mobile-item-link-expand");
    buttons.forEach((button) => {
        button.setAttribute("aria-label", "Tap to expand menu");
    });
    console.log(`Added aria-label="Tap to expand menu" to ${buttons.length} <button> elements.`);
}

function addRolePresentationToSVG() {
    const svgs = document.querySelectorAll('svg[viewBox="0 0 24 24"]');
    svgs.forEach((svg) => {
        svg.setAttribute("role", "presentation");
    });
    console.log(`Added role="presentation" to ${svgs.length} <svg> elements.`);
    
    const svgs2 = document.querySelectorAll('svg[viewBox="0 0 48 48"]');
    if (svgs2.length > 0) {
        console.log(`Found ${svgs2.length} <svg> elements with viewBox="0 0 48 48". Adding role="presentation".`);
        svgs2.forEach((svg) => {
            svg.setAttribute("role", "presentation");
        });
        console.log(`Added role="presentation" to ${svgs2.length} <svg> elements.`);
    }
}

function addRoleToButtonSpan() {
    const buttons = document.querySelectorAll("span.rte");
    buttons.forEach((button) => {
        button.setAttribute("role", "button");
        button.setAttribute("tabindex", "0");
    });
    console.log(`Added role="button" to ${buttons.length} <span class="rte" elements>`);
}

function addRoleHeadingToPriceItems() {
    const priceItems = document.querySelectorAll("span.price-item.price-item-regular");
    priceItems.forEach((span) => {
        span.setAttribute("role", "heading");
    });
    console.log(`Added role="heading" to ${priceItems.length} <span> elements.`);
}

function addRolePresentationToStockDot() {
    const stockDots = document.querySelectorAll("span.badge-stock-dot");
    stockDots.forEach((span) => {
        span.setAttribute("role", "presentation");
    });
    console.log(`Added role="presentation" to ${stockDots.length} <span> elements.`);
}

function setAriaRequiredForEmailInputs() {
    const emailInputs = document.querySelectorAll('input[type="email"]');
    emailInputs.forEach((input) => {
        input.setAttribute("aria-required", "true");
    });
    console.log(`Set aria-required="true" on ${emailInputs.length} <input type="email"> elements.`);
}

function addRoleHeadingToPriceAndMoney() {
    const spans = document.querySelectorAll("span.price-item, span.money");
    spans.forEach((span) => {
        span.setAttribute("role", "heading");
        span.setAttribute("aria-label","Pricing for item");
    });
    console.log(`Added role="heading" to ${spans.length} <span> elements.`);
}

function addAriaHasPopupToLinksWithChildren() {
    const links = document.querySelectorAll("a");
    let count = 0;
    links.forEach((link) => {
        if (link.children.length > 0) {
            link.setAttribute("aria-haspopup", "true");
            count++;
        }
    });
    console.log(`Added aria-haspopup="true" to ${count} <a> elements with children.`);
}

function toggleAriaExpanded() {
    document.querySelectorAll(".icon.icon-angle").forEach((icon) => {
        let parent = icon.parentElement;
        if (parent) {
            // Protección contra listeners duplicados
            if (parent.dataset.ariaExpandedFixed === "true") return;
            parent.dataset.ariaExpandedFixed = "true";

            parent.setAttribute("aria-expanded", "false");
            parent.addEventListener("click", function () {
                let isExpanded = this.getAttribute("aria-expanded") === "true";
                this.setAttribute("aria-expanded", isExpanded ? "false" : "true");
            });
        }
    });
}

function setAngleFontSize() {
    const angleSpans = document.querySelectorAll("span.angle");
    angleSpans.forEach((span) => {
        span.style.fontSize = "2rem";
    });
    console.log(`Set font size to 2rem for ${angleSpans.length} <span> elements with class "angle".`);
}

function addRoleNoneToVisuallyHiddenSVG() {
    const svgs = document.querySelectorAll("svg.visually-hidden");
    svgs.forEach((svg) => {
        svg.setAttribute("role", "none");
    });
    console.log(`Added role="none" to ${svgs.length} <svg> elements with class "visually-hidden".`);
}

function fixInteractiveElements() {
    const fixDropdownLinks = () => {
        const dropdownLinks = document.querySelectorAll('a[href="#"][aria-haspopup="true"]');
        dropdownLinks.forEach((link) => {
            if (link.dataset.accessibilityFixed) return;
            link.dataset.accessibilityFixed = "true";

            link.setAttribute("role", "button");

            link.addEventListener("click", (e) => {
                e.preventDefault();
            });

            link.addEventListener("keydown", (e) => {
                if (e.key === " " || e.key === "Enter") {
                    e.preventDefault();
                    link.click();
                }
            });
        });
    };

    const fixAirReviewsElements = () => {
        const selectors = [
            ".AirReviews-Blocks__ReviewDetails--AuthorBlock",
            ".AirReviews-StarRate",
            ".AirReviews-Blocks__Date",
            ".AirReviews-Blocks__Content",
            ".AirReviews-Blocks__ProductDetails"
        ].join(', '); 

        const elementsToFix = document.querySelectorAll(selectors);
        let fixedCount = 0;

        elementsToFix.forEach(el => {
            if (el.dataset.accessibilityFixed === "true") return;
            el.dataset.accessibilityFixed = "true";

            el.setAttribute("role", "button");
            el.setAttribute("tabindex", "0");

            el.addEventListener("keydown", e => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    el.click();
                }
            });

            if (el.classList.contains('AirReviews-Blocks__Content')) {
                const contentNode = el.querySelector(".Avada-ReviewContent__LimitLength");
                if (contentNode) {
                    const checkExpanded = () => {
                        const isExpanded = !contentNode.style.webkitLineClamp;
                        el.setAttribute("aria-expanded", isExpanded ? "true" : "false");
                    };
                    checkExpanded(); 
                    const expansionObserver = new MutationObserver(checkExpanded);
                    expansionObserver.observe(contentNode, { attributes: true, attributeFilter: ["style"] });
                }
            }

            if (!el.textContent.trim() && !el.hasAttribute("aria-label")) {
                if (el.className.includes("StarRate")) el.setAttribute("aria-label", "Calificación");
                else if (el.className.includes("Date")) el.setAttribute("aria-label", "Fecha reseña");
                else el.setAttribute("aria-label", "Detalles reseña");
            }
            fixedCount++;
        });

        if (fixedCount > 0) {
            console.log(`Air Reviews: ${fixedCount} elementos corregidos`);
        }
    };

    fixDropdownLinks();
    fixAirReviewsElements();
}

function fixDecorativeStars() {
    document.querySelectorAll('svg.AirReviews-Star__Classic').forEach(svg => {
        if (!svg.hasAttribute('role')) {
            svg.setAttribute('role', 'presentation');
            svg.setAttribute('aria-hidden', 'true');
        }
    });
}

function fixPaymentIcons() {
    document.querySelectorAll('svg[class*="pi-"][role="img"]').forEach(svg => {
        svg.removeAttribute('role');
        svg.setAttribute('role', 'presentation');
        svg.setAttribute('aria-hidden', 'true');
    });
}

function findFigcaption() {
    const figuresConAria = document.querySelectorAll('figure[figcaption]');
    figuresConAria.forEach(figure => {
        const labelText = figure.getAttribute('figcaption');
        figure.setAttribute('aria-label', labelText);
        figure.setAttribute('role', 'img');
        figure.removeAttribute('figcaption');
    });
}

function fixGenericLinks() {
    const genericTexts = ["view full details", "now available", "shop now", "explore here", "learn more", "read more"];
    const links = document.querySelectorAll('a');

    links.forEach(link => {
        if (link.hasAttribute('aria-label') || link.dataset.genericFixed === "true") return;

        const visibleText = link.textContent.trim().toLowerCase();

        if (genericTexts.includes(visibleText)) {
            const href = link.getAttribute('href');
            if (href && href !== "#" && href !== "/") {
                let contextUrl = href.split('/').pop().split('?')[0].replace(/-/g, ' '); 
                const originalText = link.textContent.trim();
                
                link.setAttribute('aria-label', `${originalText} - ${contextUrl}`);
                link.dataset.genericFixed = "true";
            }
        }
    });
}

function fixAriaControls() {
    const elementsWithAriaControls = document.querySelectorAll("[aria-controls]");
    let fixedCount = 0;
    let removedCount = 0;

    elementsWithAriaControls.forEach((element) => {
        const controlsId = element.getAttribute("aria-controls");
        if (!controlsId) return;

        const controlledElement = document.getElementById(controlsId);

        if (!controlledElement) {
            if (controlsId === "predictive-search-results-list") {
                const searchInput = element;
                const resultsContainer = document.createElement("div");
                resultsContainer.id = controlsId;
                resultsContainer.setAttribute("role", "listbox");
                resultsContainer.setAttribute("aria-label", "Search suggestions");
                resultsContainer.style.display = "none";

                searchInput.parentNode.insertBefore(resultsContainer, searchInput.nextSibling);
                fixedCount++;
            } else if (controlsId === "mobile-menu") {
                const menuButton = element;
                const mobileMenu = document.createElement("nav");
                mobileMenu.id = controlsId;
                mobileMenu.setAttribute("role", "navigation");
                mobileMenu.setAttribute("aria-label", "Mobile menu");
                mobileMenu.style.display = "none";
                menuButton.parentNode.insertBefore(mobileMenu, menuButton.nextSibling);
                fixedCount++;
            } else {
                element.removeAttribute("aria-controls");
                removedCount++;
            }
        }
    });
}

function fixDrawerCloseButtons() {
    const closeButtons = document.querySelectorAll(
        "button.button-drawer-header-dismiss, " +
        'button[aria-label*="Close"], ' +
        'button[class*="dismiss"]'
    );

    closeButtons.forEach((button) => {
        if (button.hasAttribute("data-accessibility-fixed")) return;
        button.setAttribute("data-accessibility-fixed", "true");

        const parentForm = button.closest("form");

        if (parentForm) {
            const isCloseButton =
                button.classList.contains("dismiss") ||
                button.getAttribute("aria-label")?.toLowerCase().includes("close") ||
                button.textContent.trim() === "×";

            if (isCloseButton) {
                if (button.type !== "submit") button.type = "submit";
                button.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                });
            }
        }
        
        if (button.textContent.trim() === "×") {
            button.removeAttribute("aria-label");
        }
    });
}

function preventAutoSubmitLocalization() {
    const form = document.getElementById('HeaderLanguageFormHeader');
    if (!form) return;

    const select = form.querySelector('select');
    if (!select) return;

    if (select.hasAttribute('onchange')) {
        select.removeAttribute('onchange');
    }

    if (!form.querySelector('.lang-apply-btn')) {
        const btn = document.createElement('button');
        btn.type = 'submit';
        btn.textContent = 'Apply';
        btn.className = 'visually-hidden lang-apply-btn'; 
        btn.setAttribute('aria-label', 'Apply selected language');
        select.after(btn);

        const live = document.createElement('div');
        live.setAttribute('aria-live', 'polite');
        live.className = 'visually-hidden';
        form.appendChild(live);

        select.addEventListener('change', () => {
            live.textContent = `Language changed to ${select.options[select.selectedIndex].text}. Press Apply to confirm.`;
        });
    }
}

function fixStickyHeaderFocus() {
    const header = document.getElementById('header');
    if (!header) return;

    const headerHeight = header.getBoundingClientRect().height;
    document.documentElement.style.scrollPaddingTop = `${headerHeight}px`;

    // Evita añadir múltiples etiquetas style si ya existe
    if (!document.getElementById('sticky-header-style')) {
        const style = document.createElement('style');
        style.id = 'sticky-header-style';
        style.textContent = `
            *:focus-visible {
                scroll-margin-top: ${headerHeight + 10}px; 
            }
        `;
        document.head.appendChild(style);
    }
}

// ==========================================
// 2. FUNCIÓN MAESTRA (Ejecuta todas las demás)
// ==========================================

function runAllFunctions() {
    assignRoleNoneToFigureCardMedia();
    assignRoleNoneToFigureWidgetMedia();
    enhanceCurrentPageLink();
    addAriaLabelToMobileExpandButton();
    addRolePresentationToSVG();
    addRoleToButtonSpan();
    addRoleHeadingToPriceItems();
    addRolePresentationToStockDot();
    setAriaRequiredForEmailInputs();
    addRoleHeadingToPriceAndMoney();
    addAriaHasPopupToLinksWithChildren();
    toggleAriaExpanded();
    setAngleFontSize();
    addRoleNoneToVisuallyHiddenSVG();
    fixInteractiveElements();
    fixDecorativeStars();
    fixPaymentIcons();
    findFigcaption();
    fixGenericLinks();
}

// ==========================================
// 3. INICIALIZACIÓN Y OBSERVERS
// ==========================================

// Observer para banderas (Zambia)
const observer = new MutationObserver((mutationsList, observer) => {
    const appElement = document.querySelector(".flags-Zambia");
    if (appElement) {
        assignRoleToFlags();
        observer.disconnect();
    }
});
observer.observe(document.body, { childList: true, subtree: true });

// Observer principal para recargas dinámicas del DOM
const observer2 = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
            // Usamos requestAnimationFrame para no saturar el hilo principal
            requestAnimationFrame(() => {
                runAllFunctions();
            });
            break; // Solo necesitamos correrlo una vez por lote de mutaciones
        }
    }
});
observer2.observe(document.body, { childList: true, subtree: true });

// Ejecuciones al cargar la página (DOMContentLoaded o inmediatas si ya cargó)
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
        runAllFunctions();
        fixAriaControls();
        fixDrawerCloseButtons();
        preventAutoSubmitLocalization();
    });
} else {
    runAllFunctions();
    fixAriaControls();
    fixDrawerCloseButtons();
    preventAutoSubmitLocalization();
}

// Timeouts de respaldo para apps externas que cargan muy lento
setTimeout(fixAriaControls, 1000);
setTimeout(fixAriaControls, 3000);
setTimeout(preventAutoSubmitLocalization, 1500);

// Fix de header sticky
fixStickyHeaderFocus();
window.addEventListener('resize', fixStickyHeaderFocus);
setTimeout(fixStickyHeaderFocus, 1000);
setTimeout(fixStickyHeaderFocus, 3000);